import { Text, View } from '@components/primitives';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import colors from '@theme/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableWithoutFeedback, ViewStyle } from 'react-native';

interface ProfileRejectedPinRowProps {
  onPressSecurityPin: (navigation: NativeStackNavigationProp<any>) => void;
  childRef?: React.RefObject<TouchableWithoutFeedback>;
}

function ProfileRejectedPinRow({ onPressSecurityPin = () => {}, childRef }: Readonly<ProfileRejectedPinRowProps>) {
  const navigation = useNavigation<NativeStackNavigationProp<any>>();
  const { t } = useTranslation('common');

  const containerStyle: ViewStyle = {
    backgroundColor: colors.error.softRose,
    borderRadius: 12,
    marginRight: 8,
  };

  return (
    // <TouchableWithoutFeedback
    //   ref={childRef}
    //   testID="btnPressSecurityPin"
    //   onPress={() => onPressSecurityPin && onPressSecurityPin(navigation)}>
    <View style={containerStyle}>
      <Text
        testID="txtSecurityPinRejected"
        marginX="8px"
        marginY="5px"
        variant="xsm-normal"
        color={colors.error.darkRose}>
        {t('profile.securityPinRejected')}
      </Text>
    </View>
    // </TouchableWithoutFeedback>
  );
}

export default ProfileRejectedPinRow;
